import { render } from "./Question.vue?vue&type=template&id=c7f61370&scoped=true"
import script from "./Question.vue?vue&type=script&lang=js"
export * from "./Question.vue?vue&type=script&lang=js"

import "./Question.vue?vue&type=style&index=0&id=c7f61370&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/stpancras-backstage-app/stpancras-backstage-app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c7f61370"]])

export default __exports__